<template>
  <div>
    <h3 class="page-header">Support</h3>
    <div class="dsp-wrapper">
      <h3>Select a local provider for contact information.</h3>
      <div class="row">
        <div class="col-md-3">
          <select class="form-control" v-model="selected" @change="getDSPInfo()">
            <option v-for="dsp in DSPs" v-bind:value="dsp.UNIX_USER">
              {{ dsp.BUS_CITY + ' - ' + dsp.BUS_NAME }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="dsp_info">
            <h4 v-if="dspInfo.BUS_NAME">{{dspInfo.BUS_NAME}}</h4>
            <p v-if="dspInfo.SITE_URL">Website: {{dspInfo.SITE_URL}}</p>
            <p v-if="dspInfo.BUS_PHONE">Phone: {{dspInfo.BUS_PHONE}}</p>
            <p v-if="dspInfo.SITE_NOTIFY_COMMENTS">Email: {{dspInfo.SITE_NOTIFY_COMMENTS}}</p>
            <p v-if="dspInfo.BUS_ADDRESS1">Address: {{dspInfo.BUS_ADDRESS1}}</p>
            <p v-if="dspInfo.BUS_CITY">City: {{dspInfo.BUS_CITY}}</p>
            <p v-if="dspInfo.BUS_STATE">State: {{dspInfo.BUS_STATE}}</p>
            <p v-if="dspInfo.BUS_ZIP">Zip: {{dspInfo.BUS_ZIP}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selected != 'null'" ref="national_support" class="support_info">
      <h3 class="national_support">National Support</h3>
      <p style="margin-bottom: 35px;">If your issue was not resolved contacting your local provider, please reach out to our national support hotline.</p>
      <div class="container-fluid">
        <div class="row">
          <div class="support-card">
            <div class="col-md-2" style="text-align: center">
              <img src="static/img/support_feedback.png" alt="">
            </div>
            <div class="col-md-10">
              <h3>We want your feedback! Email us anytime <a href="mailto:wecare@deliverlogic.com">wecare@deliverlogic.com</a></h3>
                <p>Please include following information in your email (if applicable)</p>
                <ul>
                  <li>Date and time of interaction</li>
                  <li>Customer name</li>
                  <li>Order number</li>
                  <li>Driver name (if applicable)</li>
                  <li>Deliver service (if applicable)</li>
                  <li>Detailed comments</li>
                </ul>
                <p>Feedback can include any of the following</p>
                <ul>
                  <li>Customer feedback</li>
                  <li>Wait times</li>
                  <li>Driver interaction (positive or negative)</li>
                  <li>Process improvements</li>
                  <li>Anything else you would like to communicate to us!</li>
                </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="support-card orange_sep">
            <div class="col-md-2" style="text-align: center">
              <img src="static/img/support_driver.png" alt="">
            </div>
            <div class="col-md-10">
              <h3>If the delivery service is going to be delayed for <strong>ANY</strong> reason (i.e. traffic, weather), <br/>DeliverLogic will...</h3>
              <ul>
                <li>Contact your <strong>store</strong> to advise of the new arrival time</li>
                <li>Contact your <strong>customer</strong> to provide them with a new update</li>
                <li>Provide the <strong>customer compensation</strong> for any of the following issues:</li>
                <ul>
                  <li>Excessive delivery times</li>
                  <li>Poor food quality as a result of lengthy delivery times</li>
                  <li>Food never arriving</li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
        <div class="row orange_sep">
          <div class="col-md-12">
            <h3 style="text-align: center">If you are experiencing an emergency service issue </br>please call our <strong>Emergency Support Number</strong></h3>
            <div class="" style="text-align: center">
              <img src="static/img/support_contact.png" alt="">
            </div>
            <h1 style="text-align: center">(833) 435 - 6442</h1>
          </div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
  import {API} from 'src/api'
  import moment from 'moment'

  if(localStorage.userInfo) {
    var userInfo = JSON.parse(localStorage.userInfo)
  }

  export default {
    data () {
      return {
        start_date: moment().subtract(1, 'days').toString(),
        end_date: moment().toString(),
        dspInfo: [],
        selected: 'null',
        DSPs: [
          { BUS_NAME: 'Select Your City', BUS_CITY: '', UNIX_USER: 'null' },
          { BUS_NAME: 'Corporate Support', BUS_CITY: 'DeliverLogic', UNIX_USER: 'deliverlogic' },
        ]
      }
    },
    methods: {
      getDSPInfo () {
        var self = this
        API.get('/report/dsp_info?UNIX_USER=' + this.selected)
        .then(function (response) {
          if(response.data.rv == 'undefined' || response.data.rv == null) {
            self.dspInfo = []
          } else {
            self.dspInfo = response.data.rv
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getAllDSPs () {
        var self = this
        // var Deliverlogic = {
        //   BUS_CITY: "",
        //   BUS_NAME: "DeliverLogic Corporate",
        //   UNIX_USER: "deliverlogic"
        // };
        // self.DSPs.push(Deliverlogic)
        API.get('/report/all_dsps')
        .then(function (response) {
          for (let dsp of Object.values(response.data.rv)) {
            self.DSPs.push(dsp)
          }
          console.log('DSPs', self.DSPs)
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    mounted () {
      this.getAllDSPs()
    }
  }
</script>
<style>
.support-card {
  border-radius: 4px;
  background-color: #f9f9f9;
  margin-bottom: 20px;
  position: relative;
  padding: 20px 10px 20px 0;
  float: left;
  width: 100%;
}
.support_info h3, .support-card-wide h3 {
  font-size: 24px;
}
.orange_sep {
  border-bottom: 6px solid #f79a1d;
}
.dsp-wrapper {
  margin: 50px 0 0;
  /* min-height: 250px; */
}
.dsp-wrapper h3 {
  font-weight: 600;
}
.national_support {
  margin: 30px 0 5px;
  border-top: 1px solid #808080;
  padding-top: 20px;
  color: #000;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// Support.vue?64417838